export const ACTIVITY_DETAILS_REQ = "ACTIVITY_DETAILS_REQ";
export const ACTIVITY_DETAILS_SUCCESS = "ACTIVITY_DETAILS_SUCCESS";
export const ACTIVITY_DETAILS_FAILED = "ACTIVITY_DETAILS_FAILED";
export const ACTIVITY_DETAILS_RESET = "ACTIVITY_DETAILS_RESET";

export const ACTIVITY_CREATE_REQ = "ACTIVITY_CREATE_REQ";
export const ACTIVITY_CREATE_SUCCESS = "ACTIVITY_CREATE_SUCCESS";
export const ACTIVITY_CREATE_FAILED = "ACTIVITY_CREATE_FAILED";
export const ACTIVITY_CREATE_RESET = "ACTIVITY_CREATE_RESET";

export const ACTIVITY_DETAILS_UPDATE_REQ = "ACTIVITY_DETAILS_UPDATE_REQ";
export const ACTIVITY_DETAILS_UPDATE_SUCCESS =
  "ACTIVITY_DETAILS_UPDATE_SUCCESS";
export const ACTIVITY_DETAILS_UPDATE_FAILED = "ACTIVITY_DETAILS_UPDATE_FAILED";
export const ACTIVITY_DETAILS_UPDATE_RESET = "ACTIVITY_DETAILS_UPDATE_RESET";
